









import { mapGetters } from 'vuex';
export default {
    name: "OnsiteSearchNoResult",
    computed: mapGetters(['getTranslations'])
}
